/* eslint-disable lines-around-comment */
import { LocaleService } from './locale-service';
import { hydratedData } from 'services/hydrated-data';

/**
 * Load translations and react-intl locale data for widget
 * @param {string} locale
 * @returns {Promise.<{translations, reactIntlData, locale}>}
 */
export async function loadWidgetLocaleData(locale) {
  const hydratedTranslations = hydratedData.getTranslations();

  if (hydratedTranslations) {
    return {
      locale,
      translations: hydratedTranslations,
      reactIntlData: (await import(/* webpackChunkName: "react-intl/locale-data/[request]" */
      `react-intl/locale-data/${locale}`)).default,
    };
  }

  return import(/* webpackChunkName: "locale/widget/[request]" */
  `locale/locales/widget/${locale}.js`);
}

window.__Locale = new LocaleService({
  loadLocaleData: loadWidgetLocaleData,
});
